<template>
  <div class="animated fadeIn vld-parent custom-100" >
    <b-row>
      <b-col sm="12">
        <search-bar ref="search-bar"
                   :on-search="queryData"
                   @create-definition="createDefinition"
                   @open-settings="$refs['setting-dialog'].showDialog()"
        ></search-bar>
      </b-col>
    </b-row>
    <b-row class="custom-flex-1">
      <b-col sm="12">
        <definition-table ref="definition-table"
                        :table-data="tableData"
                        @page-changed="setPage"
        ></definition-table>
      </b-col>
    </b-row>
    <settings-dialog :konto_setting="konto_settings" ref="setting-dialog" @save-settings="saveSettings"></settings-dialog>
  </div>
</template>

<script>
import searchBar from './definition_searchbar.vue';
import definitionTable from './definition_table.vue';
import settingsDialog from './SettingsDialog.vue';
import {Redirect_500, Redirect_Login, Server_URL} from "@/shared/utils";
import {
  decryptAES,
} from "@/shared/crypto";



export default {
  name: "Definitions",
  components: {
    'searchBar':searchBar, 'definitionTable': definitionTable, "settingsDialog": settingsDialog},
  data() {
    return {
      // SearchbarProps
      loader: undefined,
      data: [],
      konto_settings: [],
      currentPage: 1,
      isBauhof: false,
      query: {
        searchText: "",
        page: 1,
      },
      afterFirstQuery: false,
    }
  },
  watch: {
    currentTab(n, o) {
      if (this.afterFirstQuery) {
        this.$refs["search-bar"].searchFilter();
      }
    },
  },
  created() {
    this.isBauhof = navigator.userAgent.startsWith("Windows - BisOffice");
    this.$nextTick(() => {
      this.parseQuery()
      this.$refs["search-bar"].setQuery(this.query);
      this.queryData(this.query.searchText);
    })
  },
  computed: {
    tableData() {
      return this.data.filter(d => {
        return d.api_name.toLowerCase().includes(this.query.searchText.toLowerCase());
      });
    }
  },
  methods: {
    createDefinition() {
      this.$router.push("/auswertung/invoice_api_definitions/new");
    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    parseQuery() {
      let query = this.$route.query;
      if (query.page) {
        this.query = {
          searchText: query.searchText,
          page: query.page,
        }
      }
    },
    responseOkFetch(response) {
      this.$refs["definition-table"].currentPage = 1;
      this.$refs["search-bar"].onFirstSearch();
      if (response.status === 200) {
        let data = response.body;
        console.log(data)
        this.hideLoader();
        this.data = data.definitions;
        this.konto_settings = data.konto;
        this.$nextTick(() => {
          if (!this.afterFirstQuery) {
            this.$refs['definition-table'].changePage(this.query.page);
          }
          this.afterFirstQuery = true;
        })
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    setPage(page) {
      this.query.page = page;
      this.$router.push({query: this.query}).then(() => {}).catch(err => {});
    },
    setQueryText(searchText) {
      this.query = {
        searchText: searchText,
        page: this.query.page,
      }
    },
    saveSettings(setting) {
      this.konto_settings = setting.konto_settings;
      this.showLoader();
      this.$http.post(
          Server_URL+'/auftragsbuch/invoice_definition_settings', setting
      ).then((r) => {this.hideLoader();}, this.responseError)
    },
    queryData(searchText) {
      this.query = {
        searchText: searchText,
        page: this.query.page,
      }
      this.$router.push({query: this.query}).then(() => {
        this.showLoader();
        this.$http.get(
            Server_URL+'/auftragsbuch/invoice_definition'
        ).then(this.responseOkFetch, this.responseError)
      }).catch(e => {
        this.showLoader();
        this.$http.get(
            Server_URL+'/auftragsbuch/invoice_definition'
        ).then(this.responseOkFetch, this.responseError)
      });
    },
  },
}
</script>

<style scoped>
::v-deep .tab-content {
  display: none !important;
}

.bauhof-border {
  border-left: 5px solid #FBFBFB;
  border-right: 5px solid #FBFBFB;
}

</style>
<style>
.toast-pre-wrap {
  white-space: pre-wrap;
}
</style>
